module.exports = {"430724100":"安福镇","430724101":"合口镇","430724102":"新安镇","430724103":"佘市桥镇","430724104":"太浮镇","430724105":"四新岗镇","430724106":"停弦渡镇","430724107":"修梅镇","430724204":"烽火乡","430724209":"刻木山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430724.json
// module id = 1713
// module chunks = 0